import { render, staticRenderFns } from "./ServiceBookingNew.vue?vue&type=template&id=745425b1&scoped=true&"
import script from "./ServiceBookingNew.vue?vue&type=script&lang=js&"
export * from "./ServiceBookingNew.vue?vue&type=script&lang=js&"
import style0 from "./ServiceBookingNew.vue?vue&type=style&index=0&id=745425b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745425b1",
  null
  
)

export default component.exports